import { assign, createMachine } from "xstate";
import {
  ISetBlockUnblockStatus,
  setToggleBlockSimCard,
} from "@nju/data-access-portal-sim-card";
import { BasicError } from "@nju/result";

interface IContext {
  productId: string;
  action: ISetBlockUnblockStatus;
}

type IEvent =
  | { type: "BLOCK" }
  | { type: "UNBLOCK" }
  | { type: "SUCCESS" }
  | { type: "ERROR" };

export const mySimCardToggleBlockMachine = createMachine(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          BLOCK: {
            actions: "setBlock",
            target: "setBlockSimCard",
          },
          UNBLOCK: {
            actions: "setUnblock",
            target: "setBlockSimCard",
          },
        },
      },
      setBlockSimCard: {
        invoke: {
          src: "setBlockSimCard",
        },
        on: {
          SUCCESS: {
            target: "success",
          },
          ERROR: {
            target: "error",
          },
        },
      },
      success: {
        type: "final",
      },
      error: {
        type: "final",
      },
    },
  },
  {
    actions: {
      setBlock: assign<IContext, IEvent>((context, event) => {
        if (event.type === "BLOCK") {
          return {
            action: "block",
          };
        }

        return context;
      }),
      setUnblock: assign<IContext, IEvent>((context, event) => {
        if (event.type === "UNBLOCK") {
          return {
            action: "unblock",
          };
        }

        return context;
      }),
    },
    services: {
      setBlockSimCard: ({ productId, action }) => {
        return async (callback) => {
          if (!productId) {
            throw new BasicError({
              message: "Missing required fields productId",
            });
          }

          const result = await setToggleBlockSimCard({
            productId,
            action,
          });

          if (result.isError) {
            return callback({ type: "ERROR" });
          }

          return callback({ type: "SUCCESS" });
        };
      },
    },
  },
);
